<template>
    <div>
        <date-picker v-model="input" :type="type"></date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
  components: { DatePicker },
  props: [
    'value',
    'type'
  ],
  data: () => ({

  }),
  computed: {
    input: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {

  }
}
</script>
